import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { ICreateProgramItemActionPayload } from '../interfaces/create-program-item.action.payload.interface';
import { ProgramItemsWithGroup } from '../models/program-items-with-group.model';
import { ProgramItem } from '../models/program-item.model';
import { AssessmentCourse } from '../models/assessment-course.model';

import { IAddCourseOfferingsToCourseCategoryActionPayload } from '../interfaces/add-course-offerings-to-course-category.action.payload.interface';
import { IBookAllParticipantsToCourseExecutionActionPayload } from '../interfaces/book-all-participants-to-course-execution.action.payload.interface';
import { IChangeProgramCompletionForParticipantsActionPayload } from '../interfaces/change-program-completion-for-participants.action.payload.interface';
import { IChangeProgramCompletionResult } from '../interfaces/change-program-completion-result.interface';
import { ProgramStructureWithProgramParticipant } from '../models/program-structure-with-program-participant.model';
import { ProgramExecutionMetrics } from '../models/program-execution-metrics.model';
import { DateRange } from '../../../projects/shared/src/lib/models/date-range.model';
import { RelevantExecutionRuleEnum } from 'app/library/relevant-execution/enums/relevant-execution-rule.enum';
import { ProgramStructureWithGroup } from '../models/program-structure-with-group.model';
import { CourseRelevantExecution } from 'app/library/relevant-execution/models/course-relevant-execution.model';
import { IParticipantExecutionChangeActionPayload } from '../interfaces/participant-execution-change-action.action-payload.interface';
import { ParticipantExecutionChange } from '../models/participant-execution-change.model';
import { PartcipantCourseGroup } from '../models/participant-course-group.model';

export class SetProgramItem {
    static readonly type = '[ProgramItem] SetProgramItem';

    constructor(public payload: ProgramItem) {}
}

export class UnsetProgramItem {
    static readonly type = '[ProgramItem] UnsetProgramItem';
}

export class FetchProgramItem {
    static readonly type = '[ProgramItem] FetchProgramItem';

    constructor(public payload: string) {}
}

export class FetchProgramItemSuccess {
    static readonly type = '[ProgramItem] FetchProgramItemSuccess';

    constructor(public payload: ProgramItem) {}
}

export class FetchProgramItemFailure {
    static readonly type = '[ProgramItem] FetchProgramItemFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateProgramItem {
    static readonly type = '[ProgramItem] CreateProgramItem';

    constructor(public payload: ICreateProgramItemActionPayload) {}
}

export class CreateProgramItemSuccess {
    static readonly type = '[ProgramItem] CreateProgramItemSuccess';

    constructor(public payload: ProgramItem) {}
}

export class CreateProgramItemFailure {
    static readonly type = '[ProgramItem] CreateProgramItemFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateProgramItem {
    static readonly type = '[ProgramItem] UpdateProgramItem';

    constructor(public payload: ProgramItem) {}
}

export class UpdateProgramItemSuccess {
    static readonly type = '[ProgramItem] UpdateProgramItemSuccess';

    constructor(public payload: ProgramItem) {}
}

export class UpdateProgramItemFailure {
    static readonly type = '[ProgramItem] UpdateProgramItemFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteProgramItem {
    static readonly type = '[ProgramItem] DeleteProgramItem';

    constructor(public payload: string) {}
}

export class DeleteProgramItemSuccess {
    static readonly type = '[ProgramItem] DeleteProgramItemSuccess';

    constructor(public payload: string) {}
}

export class DeleteProgramItemFailure {
    static readonly type = '[ProgramItem] DeleteProgramItemFailure';

    constructor(public payload: string) {}
}

export class SetProgramItems {
    static readonly type = '[ProgramItem] SetProgramItems';

    constructor(public payload: ProgramItem[]) {}
}

export class SearchProgramItems {
    static readonly type = '[ProgramItem] SearchProgramItems';

    constructor(public payload: string) {}
}

export class FetchProgramItemsWithGroup {
    static readonly type = '[ProgramItem] FetchProgramItemsWithGroup';

    constructor(public payload: { categoryId: string; tags: number[]; searchTerm: string }) {}
}

export class FetchProgramItemsWithGroupSuccess {
    static readonly type = '[ProgramItem] FetchProgramItemsWithGroupSuccess';

    constructor(public payload: ProgramItemsWithGroup[]) {}
}

export class FetchProgramItemsWithGroupFailure {
    static readonly type = '[ProgramItem] FetchProgramItemsWithGroupFailure';
}

export class FetchProgramItemsByCategorySearch {
    static readonly type = '[ProgramItem] FetchProgramItemsByCategorySearch';

    constructor(public payload: { moduleId: string; tags: number[]; searchTerm: string }) {}
}

export class FetchProgramItemsByCategorySearchSuccess {
    static readonly type = '[ProgramItem] FetchProgramItemsByCategorySearchSuccess';

    constructor(public payload: ProgramItemsWithGroup[]) {}
}

export class FetchProgramItemsByCategorySearchFailure {
    static readonly type = '[ProgramItem] FetchProgramItemsByCategorySearchFailure';
}

export class AddCourseOfferingsToCourseCategory {
    static readonly type = '[ProgramItem] AddCourseOfferingsToCourseCategory';

    constructor(public payload: IAddCourseOfferingsToCourseCategoryActionPayload) {}
}
export class AddCourseOfferingsToCourseCategorySuccess {
    static readonly type = '[ProgramItem] AddCourseOfferingsToCourseCategorySuccess';

    constructor(public payload: ProgramItemsWithGroup) {}
}

export class AddCourseOfferingsToCourseCategoryFailure {
    static readonly type = '[ProgramItem] AddCourseOfferingsToCourseCategoryFailure';
}

export class BookAllParticipantsToCourseExecution {
    static readonly type = '[ProgramItem] BookAllParticipantsToCourseExecution';

    constructor(public payload: IBookAllParticipantsToCourseExecutionActionPayload) {}
}
export class BookAllParticipantsToCourseExecutionSuccess {
    static readonly type = '[ProgramItem] BookAllParticipantsToCourseExecutionSuccess';

    constructor(
        public payload: {
            asyncJobId: string;
        }
    ) {}
}

export class BookAllParticipantsToCourseExecutionFailure {
    static readonly type = '[ProgramItem] BookAllParticipantsToCourseExecutionFailure';
}

export class ChangeProgramCompletionForParticipants {
    static readonly type = '[ProgramItem] ChangeProgramCompletionForParticipants';

    constructor(public payload: IChangeProgramCompletionForParticipantsActionPayload) {}
}
export class ChangeProgramCompletionForParticipantsSuccess {
    static readonly type = '[ProgramItem] ChangeProgramCompletionForParticipantsSuccess';

    constructor(public payload: IChangeProgramCompletionResult) {}
}

export class ChangeProgramCompletionForParticipantsFailure {
    static readonly type = '[ProgramItem] ChangeProgramCompletionForParticipantsFailure';
}

export class FetchAssessmentCourses {
    static readonly type = '[ProgramItem] FetchAssessmentCourses';

    constructor(public payload: { moduleId: string; tags: number[]; searchTerm: string }) {}
}

export class FetchAssessmentCoursesSuccess {
    static readonly type = '[ProgramItem] FetchAssessmentCoursesSuccess';

    constructor(public payload: AssessmentCourse[]) {}
}

export class FetchAssessmentCoursesFailure {
    static readonly type = '[ProgramItem] FetchAssessmentCoursesFailure';
}

export class FetchProgramExecutionStatistics {
    static readonly type = '[ProgramItem] FetchProgramExecutionStatistics';

    constructor(public programExecutionId: string, public offeringIds: string[]) {}
}

export class FetchProgramExecutionStatisticsSuccess {
    static readonly type = '[ProgramItem] FetchProgramExecutionStatisticsSuccess';

    constructor(public programExecutionId: string, public offeringIdsHash: string, public payload: ProgramItemsWithGroup[]) {}
}

export class FetchProgramExecutionStatisticsFailure {
    static readonly type = '[ProgramItem] FetchProgramExecutionStatisticsFailure';

    constructor(public programExecutionId: string, public offeringIdsHash: string) {}
}

export class FetchRelevantExecutionsDateRange {
    static readonly type = '[ProgramItem] FetchRelevantExecutionsDateRange';

    constructor(public id: string) {}
}
export class FetchRelevantExecutionsDateRangeSuccess {
    static readonly type = '[ProgramItem] FetchRelevantExecutionsDateRangeSuccess';

    constructor(public payload: DateRange) {}
}

export class FetchRelevantExecutionsDateRangeFailure {
    static readonly type = '[ProgramItem] FetchRelevantExecutionsDateRangeFailure';
}

export class UpdateRelevantExecutionsDateRange {
    static readonly type = '[ProgramItem] UpdateRelevantExecutionsDateRange';

    constructor(public payload: { programExecutionId: string; dateRange: DateRange }) {}
}
export class UpdateRelevantExecutionsDateRangeSuccess {
    static readonly type = '[ProgramItem] UpdateRelevantExecutionsDateRangeSuccess';

    constructor(public payload: DateRange) {}
}

export class UpdateRelevantExecutionsDateRangeFailure {
    static readonly type = '[ProgramItem] UpdateRelevantExecutionsDateRangeFailure';
}

export class UpdateProgramItemRelevantExecutionRule {
    static readonly type = '[ProgramItem] UpdateProgramItemRelevantExecutionRule';

    constructor(public payload: { programItemId: string; relevantExecutionRule: RelevantExecutionRuleEnum }) {}
}
export class UpdateProgramItemRelevantExecutionRuleSuccess {
    static readonly type = '[ProgramItem] UpdateProgramItemRelevantExecutionRuleSuccess';

    constructor(public payload: ProgramItem) {}
}

export class UpdateProgramItemRelevantExecutionRuleFailure {
    static readonly type = '[ProgramItem] UpdateProgramItemRelevantExecutionRuleFailure';
}

export class DeleteRelevantExecutionsDateRange {
    static readonly type = '[ProgramItem] DeleteRelevantExecutionsDateRange';

    constructor(public programExecutionId: string) {}
}

export class DeleteRelevantExecutionsDateRangeSuccess {
    static readonly type = '[ProgramItem] DeleteRelevantExecutionsDateRangeSuccess';

    constructor() {}
}

export class DeleteRelevantExecutionsDateRangeFailure {
    static readonly type = '[ProgramItem] DeleteRelevantExecutionsDateRangeFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class FetchProgramExecutionMetrics {
    static readonly type = '[ProgramItem] FetchProgramExecutionMetrics';

    constructor(public id: string) {}
}
export class FetchProgramExecutionMetricsSuccess {
    static readonly type = '[ProgramItem] FetchProgramExecutionMetricsSuccess';

    constructor(public payload: ProgramExecutionMetrics) {}
}

export class FetchProgramExecutionMetricsFailure {
    static readonly type = '[ProgramItem] FetchProgramExecutionMetricsFailure';
}

export class FetchParticipantProgramExecution {
    static readonly type = '[ProgramItem] FetchParticipantProgramExecution';

    constructor(public programCourseId: string, public userId: string) {}
}
export class FetchParticipantProgramExecutionSuccess {
    static readonly type = '[ProgramItem] FetchParticipantProgramExecutionSuccess';

    constructor(public payload: ProgramStructureWithProgramParticipant) {}
}

export class FetchParticipantProgramExecutionFailure {
    static readonly type = '[ProgramItem] FetchParticipantProgramExecutionFailure';
}

export class FetchParticipantProgramExecutionGroup {
    static readonly type = '[ProgramItem] FetchParticipantProgramExecutionGroup';

    constructor(public programCourseId: string, public courseGroupId: string, public userId: string) {}
}
export class FetchParticipantProgramExecutionGroupSuccess {
    static readonly type = '[ProgramItem] FetchParticipantProgramExecutionGroupSuccess';

    constructor(public programCourseId: string, public courseGroupId: string, public payload: PartcipantCourseGroup) {}
}

export class FetchParticipantProgramExecutionGroupFailure {
    static readonly type = '[ProgramItem] FetchParticipantProgramExecutionGroupFailure';

    constructor(public programCourseId: string, public courseGroupId: string) {}
}

export class FetchProgramExecutionStructureWithDefaultExecutions {
    static readonly type = '[ProgramItem] FetchProgramExecutionStructureWithDefaultExecutions';

    constructor(
        public payload?: {
            programExecutionId: string;
        }
    ) {}
}

export class FetchProgramExecutionStructureWithDefaultExecutionsSuccess {
    static readonly type = '[ProgramItem] FetchProgramExecutionStructureWithDefaultExecutionsSuccess';

    constructor(public payload: ProgramStructureWithGroup[]) {}
}

export class FetchProgramExecutionStructureWithDefaultExecutionsFailure {
    static readonly type = '[ProgramItem] FetchProgramExecutionStructureWithDefaultExecutionsFailure';
}

export class FetchProgramExecutionCourseOfferingRelevantExecutions {
    static readonly type = '[ProgramItem] FetchProgramExecutionCourseOfferingRelevantExecutions';

    constructor(
        public payload?: {
            programExecutionId: string;
            courseOfferingId: string;
            context?: string;
        }
    ) {}
}

export class FetchProgramExecutionCourseOfferingRelevantExecutionsSuccess {
    static readonly type = '[ProgramItem] FetchProgramExecutionCourseOfferingRelevantExecutionsSuccess';

    constructor(public payload: CourseRelevantExecution[]) {}
}

export class FetchProgramExecutionCourseOfferingRelevantExecutionsFailure {
    static readonly type = '[ProgramItem] FetchProgramExecutionCourseOfferingRelevantExecutionsFailure';
}

export class FetchProgramParticipantExecutionChanges {
    static readonly type = '[ProgramItem] FetchProgramParticipantExecutionChanges';

    constructor(public payload: IParticipantExecutionChangeActionPayload) {}
}

export class FetchProgramParticipantExecutionChangesSuccess {
    static readonly type = '[ProgramItem] FetchProgramParticipantExecutionChangesSuccess';

    constructor(public payload: ParticipantExecutionChange[]) {}
}

export class FetchProgramParticipantExecutionChangesFailure {
    static readonly type = '[ProgramItem] FetchProgramParticipantExecutionChangesFailure';
}

export class FetchTeamParticipantProgramExecutionGroup {
    static readonly type = '[ProgramItem] FetchTeamParticipantProgramExecutionGroup';

    constructor(public teamId: string, public programCourseId: string, public courseGroupId: string, public userId: string) {}
}
export class FetchTeamParticipantProgramExecutionGroupSuccess {
    static readonly type = '[ProgramItem] FetchTeamParticipantProgramExecutionGroupSuccess';

    constructor(public programCourseId: string, public courseGroupId: string, public payload: PartcipantCourseGroup) {}
}

export class FetchTeamParticipantProgramExecutionGroupFailure {
    static readonly type = '[ProgramItem] FetchTeamParticipantProgramExecutionGroupFailure';

    constructor(public programCourseId: string, public courseGroupId: string) {}
}

export class FetchTeamParticipantProgramExecution {
    static readonly type = '[ProgramItem] FetchTeamParticipantProgramExecution';

    constructor(public teamId: string, public programCourseId: string, public userId: string) {}
}
export class FetchTeamParticipantProgramExecutionSuccess {
    static readonly type = '[ProgramItem] FetchTeamParticipantProgramExecutionSuccess';

    constructor(public payload: ProgramStructureWithProgramParticipant) {}
}

export class FetchTeamParticipantProgramExecutionFailure {
    static readonly type = '[ProgramItem] FetchTeamParticipantProgramExecutionFailure';
}
